// extracted by mini-css-extract-plugin
export default {"main":"SignUpMain_main__1z28p","buttons":"SignUpMain_buttons__6i70Z"};